import DeleteConfirmation from 'components/modal/delete-confirmation'
import InputTypeBasic  from './input-type-basic'
import InputTypeDetailed from './input-type-detailed'

export default {
  DeleteConfirmation,
  InputTypeBasic,
  InputTypeDetailed
}
